import { Component, OnInit, ChangeDetectionStrategy, Input, Renderer2, ChangeDetectorRef, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';

import * as State from '@shared/state/interface';
import { Controllers } from '@shared/core/controllers';
import { TilesComponent } from '../../tiles.shared.component';

import { Observable, of } from 'rxjs';
import { map, combineLatest } from 'rxjs/operators';
import { ILoyaltyAppMessageModel } from '@shared/state/interface';

@Component({
    selector: 'shared-tile-for-loyalty-message',
    templateUrl: './tile-for-loyalty-message.shared.component.html',
    styleUrls: ['./tile-for-loyalty-message.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileForLoyaltyMessageComponent extends TilesComponent {
    @Input() public inverted: boolean = false;
    @Input() public message: ILoyaltyAppMessageModel;

    public handleLinkClick($event: Event): void {
        if (this.message.Url) {
            window.open(this.message.Url, '_blank').focus();
        }
    }
}
